import React, { useState } from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Nav,
  Row,
} from "react-bootstrap";

// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { Query, useMutation } from "react-apollo";
import { GET_APP_USERS, GET_CLIENTS } from "./queries";

import map from "lodash/map";
import compact from "lodash/compact";
import cloneDeep from "lodash/cloneDeep";
import set from "lodash/set";
import withSession from "./withSession";
import toLower from "lodash/toLower";
import filter from "lodash/filter";
import find from "lodash/find";
import {
  ADD_APP_USER,
  ADD_CLIENT,
  ADD_UNOFFICAL_TEAM_MEMBER,
  CANCEL_USER,
  CHANGE_APP_USER_PASSWORD,
  DELETE_APP_USER,
  DELETE_APP_USER_SUBSCRIPTION,
  DELETE_CLIENT,
  REMOVE_TEAM_MEMBER,
  UPDATE_APP_USER,
  UPDATE_CLIENT,
} from "./mutations";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";

function Clients(props) {
  const [modal, setModal] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);

  const [name, setName] = React.useState("");
  const [appName, setAppName] = React.useState("");
  const [clientId, setClientId] = React.useState("");

  const [clientInput, setClientInput] = React.useState({});

  const [addClient] = useMutation(ADD_CLIENT);
  const [updateClient] = useMutation(UPDATE_CLIENT);
  const [deleteClient] = useMutation(DELETE_CLIENT);

  const handleOpenEdit = (client) => {
    setModal(true);
    setClientId(client._id);
    setName(client.name);
    setAppName(client.appName);
    setClientInput({
      // storeSignup: client?.storeSignup,
      vibeonixApiKey: client?.vibeonixApiKey,
      webhookApiKey: client?.webhookApiKey,
      androidPackageName: client?.androidPackageName,
      googleServiceEmail: client?.googleServiceEmail,
      googleServicePrivateKey: client?.googleServicePrivateKey,
      appleSharedSecret: client?.appleSharedSecret,
      stripeApiKey: client?.stripeApiKey,
      stripeApiKeyDev: client?.stripeApiKeyDev,
      appStoreURL: client?.appStoreURL,
      playStoreURL: client?.playStoreURL,
    });
  };

  const handleOpenDelete = (client) => {
    setDeleteModal(true);
    setClientId(client._id);
  };

  const handleCloseDelete = (user) => {
    setDeleteModal(false);
    setClientId("");
  };

  const handleClose = () => {
    setModal(false);
    setClientId("");
    setName("");
    setAppName("");
    setClientInput({});
  };

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    let newInput = cloneDeep(clientInput);
    set(newInput, name, value);
    setClientInput(newInput);
  };

  const handleAddClient = () => {
    addClient({
      variables: {
        clientInput: {
          name,
          appName,
          ...clientInput,
        },
      },
      refetchQueries: [
        {
          query: GET_CLIENTS,
        },
      ],
    })
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleEditClient = () => {
    updateClient({
      variables: {
        clientId: clientId,
        clientInput: {
          name,
          appName,
          ...clientInput,
        },
      },
      refetchQueries: [
        {
          query: GET_CLIENTS,
        },
      ],
    })
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleDelete = () => {
    deleteClient({
      variables: {
        clientId: clientId,
      },
      refetchQueries: [
        {
          query: GET_CLIENTS,
        },
      ],
    })
      .then(() => {
        handleCloseDelete();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const tableColumns = [
    {
      header: "Name",
      accessorKey: "name",
    },
    {
      header: "App Name",
      accessorKey: "appName",
    },
    {
      header: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableColumnFilter: false,
      skipCSVDownload: true,
      cell: ({ row }) => {
        const client = row.original;
        return (
          // we've added some custom button actions
          <div className="actions-right">
            {/* use this button to add a edit kind of action */}
            {/* <Button
                  variant="info"
                  size="sm"
                  className="text-info btn-link edit"
                  onClick={() => handleOpenEdit(user)}
                >
                  <i className="fa fa-info" />
                </Button>{" "} */}
            <Button
              variant="warning"
              size="sm"
              className="text-warning btn-link edit"
              onClick={() => handleOpenEdit(client)}
            >
              <i className="fa fa-edit" />
            </Button>{" "}
            <Button
              variant="danger"
              size="sm"
              className="text-danger btn-link edit"
              onClick={() => handleOpenDelete(client)}
            >
              <i className="fa fa-trash" />
            </Button>{" "}
          </div>
        );
      },
    },
  ];

  return (
    <Query query={GET_CLIENTS}>
      {({ loading, data, refetch }) => {
        if (loading) return "Loading...";
        const tableData = map(data.getClients, (client, key) => {
          return {
            id: key,
            ...client,
          };
        });
        return (
          <>
            <Container fluid>
              <Row>
                <Col md="12" style={{ fontSize: "13px" }}>
                  <h4 className="title">Clients</h4>
                  <Card>
                    <Card.Body>
                      <ReactTable
                        data={tableData}
                        columns={tableColumns}
                        /*
                              You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                            */
                        className="-striped -highlight primary-pagination"
                      />
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs="6" style={{ marginTop: 25, textAlign: "left" }}>
                  <CSVLink
                    data={tableData}
                    headers={compact(
                      map(tableColumns, (column) => {
                        if (!column.skipCSVDownload)
                          return {
                            label: column.header,
                            key: column.accessorKey,
                          };
                      })
                    )}
                  >
                    Download Clients
                  </CSVLink>
                </Col>
                <Col xs="6" style={{ marginTop: 25, textAlign: "right" }}>
                  <Button
                    onClick={() => setModal(!modal)}
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    Add Client
                  </Button>
                </Col>
              </Row>
            </Container>
            <Modal
              className="modal-primary"
              onHide={handleClose}
              show={modal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>{!clientId ? "Add Client" : "Edit Client"}</label>
              </Modal.Header>
              <Modal.Body>
                <Form action="#" method="#">
                  <Form.Group>
                    <label>Client Name</label>
                    <Form.Control
                      value={name}
                      placeholder="Enter First Name"
                      type="text"
                      onChange={(event) => setName(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>App Name</label>
                    <Form.Control
                      value={appName}
                      placeholder="Enter Last Name"
                      type="text"
                      onChange={(event) => setAppName(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Vibeonix Api Key</label>
                    <Form.Control
                      name="vibeonixApiKey"
                      value={clientInput?.vibeonixApiKey}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Webhook Api Key</label>
                    <Form.Control
                      name="webhookApiKey"
                      value={clientInput?.webhookApiKey}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Android Package Name</label>
                    <Form.Control
                      name="androidPackageName"
                      value={clientInput?.androidPackageName}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Apple Shared Secret</label>
                    <Form.Control
                      name="appleSharedSecret"
                      value={clientInput?.appleSharedSecret}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>App Store URL</label>
                    <Form.Control
                      name="appStoreURL"
                      value={clientInput?.appStoreURL}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Play Store URL</label>
                    <Form.Control
                      name="playStoreURL"
                      value={clientInput?.playStoreURL}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Stripe Api Key</label>
                    <Form.Control
                      name="stripeApiKey"
                      value={clientInput?.stripeApiKey}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Stripe Dev Api Key</label>
                    <Form.Control
                      name="stripeApiKeyDev"
                      value={clientInput?.stripeApiKeyDev}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Google Service Email</label>
                    <Form.Control
                      name="googleServiceEmail"
                      value={clientInput?.googleServiceEmail}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Google Service Private Key</label>
                    <Form.Control
                      name="googleServicePrivateKey"
                      value={clientInput?.googleServicePrivateKey}
                      type="text"
                      onChange={handleChangeInput}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleClose}
                  variant="link"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={clientId ? handleEditClient : handleAddClient}
                  variant="outlined"
                  color="primary"
                  disabled={!name || !appName}
                >
                  Save
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleCloseDelete}
              show={deleteModal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Delete Client</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this client? This action cannot
                be undone
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleCloseDelete}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={handleDelete}
                  variant="danger"
                  color="primary"
                >
                  Delete Client
                </Button>
              </div>
            </Modal>
          </>
        );
      }}
    </Query>
  );
}

export default withSession(Clients);
